"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

var Chart = require("chart.js");

exports.default = {
  props: {
    chart: {
      type: Object,
      required: true
    },

    name: {
      type: String,
      required: false,
      default: ""
    }
  },

  mounted: function mounted() {
    this.render();
  },


  methods: {
    render: function render() {
      var chart = new Chart(this.$refs.canvas, {
        type: "line",
        data: {
          labels: this.chart.labels,
          datasets: [{
            label: null,
            backgroundColor: this.chart.backgroundColor,
            borderColor: this.chart.backgroundColor,
            data: this.chart.values,
            fill: false,
            pointRadius: 7,
            pointHoverRadius: 8
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: { display: false },
          title: {
            display: true,
            text: this.name.replace(/<\/?[^>]+(>|$)/g, "")
          },
          layout: {
            padding: {
              left: 10,
              right: 0,
              top: 0,
              bottom: 0
            }
          },
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: false,
                suggestedMax: 1.1 * Math.max.apply(null, this.chart.values),
                suggestedMin: 0.9 * Math.min.apply(null, this.chart.values)
              }
            }]
          },
          spanGaps: true
        }
      });
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/dashboard/ChartListItem.vue
// module id = Tg3k
// module chunks = 0 1